<template>
  <div class="item">
    <restaurant-navigation-category-title-layout
      :title="title"
      :category-icon="categoryIcon"
      :has-alerted-child="hasAlertedChild"
      class="item__title title"
      @click.native="isCollapsed = !isCollapsed"
    >
      <toggle-collapse-button
        slot="action"
        :is-collapsed="isCollapsedValue"
        class="title__toggle-button"
      />
    </restaurant-navigation-category-title-layout>
    <vertical-collapse-transition>
      <ul v-show="!isCollapsedValue">
        <li
          v-for="(detailLink, index) in formattedChildren"
          :key="index"
        >
          <restaurant-navigation-detail-link-item
            v-bind="detailLink"
            @click.native="$emit('click', detailLink)"/>
        </li>
      </ul>
    </vertical-collapse-transition>
  </div>
</template>

<script>
import { categoryItemProps } from '@/mikan/_shared/types/vueTypes/restaurantNavigation';
import {
  isPathMatched,
  getCategoryIconNameFromTitle,
  hasRelationPath,
} from '@/mikan/_shared/lib/componentHelpers/formatRestaurantNavigationItems';
import RestaurantNavigationCategoryTitleLayout from '@/mikan/_shared/components/molecules/RestaurantNavigationCategoryTitleLayout.vue';
import ToggleCollapseButton from '@/mikan/_shared/components/atoms/ToggleCollapseButton.vue';
import RestaurantNavigationDetailLinkItem from '@/mikan/_shared/components/molecules/RestaurantNavigationDetailLinkItem.vue';
import VerticalCollapseTransition from '@/mikan/_shared/components/transitions/VerticalCollapseTransition.vue';

export default {
  components: {
    RestaurantNavigationCategoryTitleLayout,
    ToggleCollapseButton,
    RestaurantNavigationDetailLinkItem,
    VerticalCollapseTransition,
  },
  props: {
    ...categoryItemProps,
    isForceCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: false,
    };
  },
  computed: {
    categoryIcon() {
      return getCategoryIconNameFromTitle(this.title);
    },
    formattedChildren() {
      return this.children.map(child =>
        child.relations?.length > 0
          ? {
              ...child,
              isActive:
                isPathMatched(window.location.pathname, child.path) ||
                hasRelationPath(window.location.pathname, child.relations),
            }
          : {
              ...child,
              isActive: isPathMatched(window.location.pathname, child.path),
            }
      );
    },
    hasActiveChild() {
      return this.formattedChildren.some(child => child.isActive);
    },
    hasAlertedChild() {
      return this.children.some(child => child.hasAlert);
    },
    isCollapsedValue() {
      if (this.isForceCollapse) {
        return true;
      }
      return this.isCollapsed;
    },
  },
  mounted() {
    this.isCollapsed = !this.hasActiveChild;
  },
  updated() {
    if (this.isForceCollapse) {
      this.isCollapsed = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';

.item {
  user-select: none;

  &__title {
    &:hover {
      cursor: pointer;
    }
  }
}

.title {
  $root: &;

  &__toggle-button {
    flex: 0 0 auto;
    font-size: 1em;

    @at-root #{$root}:hover & {
      color: $color-text-link;
    }
  }
}
</style>
